import React from 'react';
import { Title, Meta } from 'react-head';

import { I18n } from 'react-redux-i18n';

export const LocalizedTitle = ({ id }) => {
  return <Title>{I18n.t(id)}</Title>;
};

export const LocalizedMeta = ({ name, id }) => {
  return <Meta name="description" content={I18n.t(id)} />;
};

const Head = ({ children }) => {
  return (
    <React.Fragment>
      <LocalizedTitle id="seo.default.title" />
      <LocalizedMeta id="seo.default.description" name="description" />
      {children}
    </React.Fragment>
  );
};

export default Head;
